<script setup lang="ts">
import { SparklesIcon } from '@heroicons/vue/24/outline'

import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import { translationFunctionCommon, translationFunctionDefault } from '@/utilities/translations'

import ButtonPrimary from './buttons/ButtonPrimary.vue'
import ButtonSecondary from './buttons/ButtonSecondary.vue'

defineProps<{
  loading?: boolean | undefined
  show?: boolean
}>()

const emit = defineEmits<{ acceptAiFields: []; clearAiFields: [] }>()

const tfCommon = translationFunctionCommon()
const tfDefault = translationFunctionDefault()

const onClearAiFields = (): void => {
  emit('clearAiFields')
}

const onAcceptAiFields = (): void => {
  emit('acceptAiFields')
}
</script>

<template>
  <div
    v-if="show"
    class="mx-8 mb-8 rounded-xl bg-[linear-gradient(135deg,#cae8ff,#007ddd)] p-px"
    :data-testid="TEST_IDS_CREATE.aiSuggestionBox.root"
  >
    <div class="flex flex-col gap-2 rounded-[11px] bg-lochmara-50 p-5">
      <div class="flex items-start gap-2 text-base font-medium leading-6 text-lochmara-600">
        <SparklesIcon aria-hidden="true" class="size-6 shrink-0 pt-px text-lochmara-500" />
        <span>{{ tfDefault('editRelationGroup.aiSuggestionQuestion') }}</span>
      </div>
      <div class="flex justify-end gap-3 pt-2">
        <ButtonSecondary
          :data-testid="TEST_IDS_CREATE.aiSuggestionBox.delete"
          :disabled="loading ?? false"
          :label="tfCommon('button.delete')"
          @click="onClearAiFields"
        />
        <ButtonPrimary
          :data-testid="TEST_IDS_CREATE.aiSuggestionBox.accept"
          :label="tfCommon('button.accept')"
          :loading="loading"
          small
          @click="onAcceptAiFields"
        />
      </div>
    </div>
  </div>
</template>
